import styled from 'styled-components';
import BurgerIconSVG from '../../assets/images/burger-icon.svg';

const BurgerIcon = styled.span`
  background: url(\"${BurgerIconSVG}\") no-repeat center center;
  background-size: 30px 45px;
  display: block;
  height: 35px;
  width: 45px;
  min-width: 45px;
  position: relative;
  cursor: pointer;
`;

export default BurgerIcon;
